import React from "react";

import { goTo, useNavigate } from "utils";

import { Card, Col, Icon, Row } from "components";

export const Alerts = ({ alerts }) => {
  const navigate = useNavigate();

  return (
    <section className="container">
      <Row>
        {/* prelint-ignore-col */}
        {alerts.verifications > 0 && (
          <Col sm={24} md={8}>
            <Card className="content-card red margin-0" onClick={(e) => goTo(e, navigate, "/farms/verifications")}>
              <div className="icon-container">
                <Icon iconName="tabler/trophy" size="m" color="white" />
              </div>
              <div className="content">
                <h5 className="white-text">{alerts.verifications} pending verifications</h5>
                <p className="paragraph-s">Click me to review all verifications</p>
              </div>
            </Card>
          </Col>
        )}
        {alerts.invekos > 0 && (
          <Col sm={24} md={8}>
            <Card bordered={false} className="content-card orange margin-0" onClick={(e) => goTo(e, navigate, "/farms/shapefiles")}>
              <div className="icon-container">
                <Icon iconName="tabler/file" size="m" color="white" />
              </div>
              <div className="content">
                <h5 className="white-text">{alerts.invekos} recent unprocessed shapefiles</h5>
                <p className="paragraph-s">Click me to view all shapefiles</p>
              </div>
            </Card>
          </Col>
        )}
      </Row>
    </section>
  );
};
